let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5NEf1")).then(() => parcelRequire('e1xJu'));